import { render, staticRenderFns } from "./DayNumberComponent.vue?vue&type=template&id=a160be96&scoped=true"
import script from "./DayNumberComponent.vue?vue&type=script&lang=js"
export * from "./DayNumberComponent.vue?vue&type=script&lang=js"
import style0 from "./DayNumberComponent.vue?vue&type=style&index=0&id=a160be96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a160be96",
  null
  
)

export default component.exports